<template>
  <div>
    <el-col :span="24">
      <div class="titleTop">
        <h5 style="margin: 0;">
          Interactive map distribution
        </h5>
      </div>
    </el-col>
    <el-col :span="24">
      <div id="main" style="height:300px;"></div>
    </el-col>
  </div>
</template>
<script>
import { pathConfig } from '../assets/util/baseConfig'
require('../../static/world.js')

export default {
  data() {
    return {
      apiPath: pathConfig.apiPath + pathConfig.informationPath,
      indexImgPath: pathConfig.indexImgPath,
      picList: []
    }
  },
  mounted() {
    this.drawMapword()
  },
  methods: {
    drawMapword() {
      // 基于准备好的dom，初始化echarts实例
      let myChart111 = this.$echarts.init(document.getElementById('main'))
      // 绘制图表
      let geoCoordMap = {
        Aichi: [127.7685, 26.2676],
        Alberta: [-114.511042211, 55.169509257],
        Anhui: [117.0, 32.0],
        Australia: [134.484031198, -25.70993157],
        Bratislava: [17.10699, 48.14924],
        'Brevig Mission': [-166.48623, 65.33209],
        Brisbane: [153.02334, -27.46844],
        'British Columbia': [-125.104094856, 54.5618607],
        California: [-119.27023, 36.374105693],
        England: [-1.458633911, 52.592743016],
        'Hong Kong': [114.133713499, 22.364723182],
        Hubei: [116.91804, 24.57907],
        India: [79.443326548, 23.379379735],
        Iowa: [-93.499972411, 42.074698104],
        Italy: [12.83333, 42.83333],
        Jiangsu: [120.0, 33.0],
        Kawasaki: [139.702437904, 35.529941689],
        Kentucky: [-85.287620068, 37.527232524],
        Malaysia: [112.5, 2.5],
        Memphis: [-90.04925, 35.14976],
        Mexico: [-102.548353419, 23.95282499],
        Moscow: [37.61502, 55.75696],
        Netherlands: [5.616126398, 52.249375293],
        'New Caledonia': [165.701841842, -21.307791316],
        'New Jersey': [-74.728565, 39.613348353],
        Panama: [-79.972926137, 8.93960446],
        Poland: [19.398768986, 52.123790154],
        'Puerto Rico': [-66.468953431, 18.222606498],
        Russia: [96.805371534, 61.989526183],
        Singapore: [103.816509136, 1.353443997],
        Texas: [-99.33305009, 31.462733046],
        Thailand: [101.012239206, 15.116802787],
        Turkey: [35.142286272, 39.066250645],
        Vietnam: [107.83333, 16.16667],
        Wellington: [174.776048372, -41.284849758],
        Wisconsin: [-89.739185424, 44.644833367]
      }
      let convertData = function(data) {
        let res = []
        for (let i = 0; i < data.length; i++) {
          let geoCoord = geoCoordMap[data[i].name]
          if (geoCoord) {
            res.push({
              name: data[i].name,
              value: geoCoord.concat(data[i].value)
            })
          }
        }
        return res
      }

      let option = {
        backgroundColor: '#000000',
        title: {
          text: '时间轴散点图',
          subtext: 'data from ',
          sublink: '',
          x: 'center',
          textStyle: {
            color: '#000'
          }
        },
        baseOption: {
          timeline: {
            // 时间轴样式
            axisType: 'category',
            data: ['1911-1935', '1961-1985', '1986-2010', '2011-2035'],
            playInterval: 900,
            bottom: '0',
            left: '70',
            right: '70',
            symbolSize: 10,
            autoPlay: true,
            loop: true,
            realtime: true,
            lineStyle: {
              color: '#466872',
              width: 3
            },
            label: {
              color: '#466872',
              fontSize: 14
            }
          },
          grid: {
            // echarts地图距离容器位置
            left: '14%',
            right: '2%',
            bottom: '70%',
            top: '2%',
            containLabel: false
          },
          visualMap: {
            min: 0,
            max: 14,
            calculable: true,
            inRange: {
              color: ['#50a3ba', '#eac736', '#d94e5d']
            },
            textStyle: {
              color: '#000000'
            }
          },
          geo: {
            roam: true,
            map: 'world', // 设置地图属于哪个地点，根据插件china.json设置
            label: {
              emphasis: {
                show: true,
                color: '#b1b1b1' // 地点显示名称
              }
            },

            itemStyle: {
              normal: {
                areaColor: '#323c48',
                borderColor: '#111'
              },
              emphasis: {
                areaColor: '#2a333d'
              }
            }
          },
          toolbox: {
            // show: true,
            itemSize: 20,
            itemGap: 30,
            right: 50,
            feature: {
              //                            dataView: {show:true},
              // dataView: { show: true },
              restore: {
                show: true,
                title: 'Reset'
              },
              saveAsImage: {
                // excludeComponents :['toolbox'],
                pixelRatio: 2,
                title: 'Save the picture'
              }
            }
          },

          tooltip: {
            show: true,
            trigger: 'item'
          },
          series: [
            {
              type: 'scatter',
              coordinateSystem: 'geo',
              symbolSize: 8,
              itemStyle: {
                normal: {
                  color: '#D2D531'
                }
              },
              label: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: false
                }
              },

              tooltip: {
                formatter: function(params) {
                  return params.name
                }
              }
            },
            {
              type: 'scatter',
              coordinateSystem: 'geo',
              symbolSize: 8,
              itemStyle: {
                normal: {
                  color: '#D2D531'
                }
              },
              tooltip: {
                formatter: function(params) {
                  return params.name
                }
              }
            },
            {
              type: 'scatter',
              coordinateSystem: 'geo',
              symbolSize: 8,
              itemStyle: {
                normal: {
                  color: '#D2D531'
                }
              },
              tooltip: {
                formatter: function(params) {
                  return params.name
                }
              }
            }
          ]
        },
        options: [
          {
            series: {
              data: convertData([
                { name: 'Brevig Mission', value: 2 },
                { name: 'Hong Kong', value: 1 },
                { name: 'Iowa', value: 1 },
                { name: 'Puerto Rico', value: 4 },
                { name: 'Wisconsin', value: 3 }
              ])
            }
          },
          {
            series: {
              data: convertData([
                { name: 'Aichi', value: 3 },
                { name: 'Bratislava', value: 1 },
                { name: 'Hong Kong', value: 14 },
                { name: 'Memphis', value: 1 },
                { name: 'New Jersey', value: 1 },
                { name: 'Russia', value: 1 }
              ])
            }
          },
          {
            series: {
              data: convertData([
                { name: 'Alberta', value: 1 },
                { name: 'Anhui', value: 1 },
                { name: 'Australia', value: 1 },
                { name: 'Brisbane', value: 2 },
                { name: 'British Columbia', value: 1 },
                { name: 'California', value: 3 },
                { name: 'England', value: 3 },
                { name: 'Hong Kong', value: 3 },
                { name: 'Hubei', value: 2 },
                { name: 'India', value: 1 },
                { name: 'Italy', value: 1 },
                { name: 'Jiangsu', value: 4 },
                { name: 'Kawasaki', value: 5 },
                { name: 'Kentucky', value: 2 },
                { name: 'Malaysia', value: 5 },
                { name: 'Mexico', value: 3 },
                { name: 'Moscow', value: 1 },
                { name: 'Netherlands', value: 2 },
                { name: 'New Caledonia', value: 1 },
                { name: 'Panama', value: 1 },
                { name: 'Poland', value: 1 },
                { name: 'Singapore', value: 1 },
                { name: 'Texas', value: 1 },
                { name: 'Thailand', value: 1 },
                { name: 'Turkey', value: 2 },
                { name: 'Vietnam', value: 8 },
                { name: 'Wellington', value: 1 },
                { name: 'Wisconsin', value: 1 }
              ])
            }
          },
          {
            series: {
              data: convertData([
                { name: 'Anhui', value: 4 },
                { name: 'India', value: 3 }
              ])
            }
          }
        ]
      }

      myChart111.setOption(option)
    }
  }
}
</script>

<style scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

#main {
  background: #eeeeee;
  border: 1px solid rgb(224, 221, 221) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/bottomMap.vue